// extracted by mini-css-extract-plugin
module.exports = {"NotFound":"NotFound_NotFound__2i7QG"};